import React from "react";
import Toolbar from "@mui/material/Toolbar";
import { Theme } from "@mui/material/styles";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { CSSProperties } from "@mui/styles";

interface ITabContentToolbar {
  toolBarStyles?: CSSProperties;
}

const useStyles = makeStyles<Theme, {toolbarStyles: CSSProperties}>((theme: Theme) =>
  createStyles({
    toolbar: ({ toolbarStyles }) => ({
      backgroundColor: theme.palette.background.paper,
      boxSizing: "border-box",
      justifyContent: "space-between",
      marginTop: -48,
      padding: "0 5px",
      position: "sticky",
      top: 0,
      width: "100%",
      zIndex: 3,
      ...toolbarStyles
    })
  })
);

const TabContentToolbar: React.FunctionComponent<ITabContentToolbar> = props => {
  const classes = useStyles({toolbarStyles: {...props.toolBarStyles}});

  return (
    <Toolbar variant="dense" disableGutters className={classes.toolbar}>
      {props.children}
    </Toolbar>
  );
}

export default TabContentToolbar;